import React from "react"
import ReactTimeAgo from 'react-time-ago'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons"

class Review extends React.Component{
    render(){
        const { upvote, comment, date, editable, editReview, user} = this.props
        return(
            <div className="review">
                {user &&
                <div className="reviewer">{user}</div>
                }
                {upvote 
                ? <div className="reviewUpvote">
                    <FontAwesomeIcon icon={faThumbsUp} size="lg"/>
                </div>
                : user && <span>doesn't recommend</span>
                }
                <div className="reviewText">
                    {comment}
                </div>
                <div className="reviewerInfo">
                    <span className="date"><ReactTimeAgo date={new Date(date)} /></span>
                    {editable? 
                    <button className="editReview" onClick={editReview}>Edit</button>
                    : null}
                </div> 
            </div>
        )
    }
}

export default Review